import { render, staticRenderFns } from "./Subnavbar-configs.vue?vue&type=template&id=fd45856c&scoped=true"
import script from "./Subnavbar-configs.vue?vue&type=script&lang=js"
export * from "./Subnavbar-configs.vue?vue&type=script&lang=js"
import style0 from "./Subnavbar-configs.vue?vue&type=style&index=0&id=fd45856c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd45856c",
  null
  
)

export default component.exports